import React, { useState }  from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Image, Button } from 'elements';
import { MainMenu, LanguageSwitcher } from 'components';
import strings from '../../utils/translationStrings';
import './Header.scss';

export const Header = (props) => {
  Header.propTypes = {
    lang: PropTypes.string.isRequired,
    setLanguage: PropTypes.func.isRequired
  };

  const [ menuOpened, setMenuOpened ] = useState(false);

  const { lang, setLanguage } = props;

  return (
    <section id="header">
      <div className="header">
        <Link to="/">
          <Image
            width="170px"
            height="43px"
            source="/resources/images/assets/Market8_Logo.svg"
          />
        </Link>
        <div className="header__burger" onClick={() => setMenuOpened(!menuOpened)} />
        <div className={`header__container mobile-menu${menuOpened ? '-active' : ''}`}>
          <div className="header-mobile__close" onClick={() => setMenuOpened(!menuOpened)}>&times;</div>
          <div className="header__container--left">
            <MainMenu
              items={[
                {
                  title: strings.menu.docs,
                  to: 'https://docs.market8.com',
                  external: true
                },
                {
                  title: strings.menu.support,
                  to: `/${lang}/support`
                }
              ]}
            />
          </div>
          <div className="header__container--right">
            <Button action={() => window.location.replace(`${process.env.REACT_APP_DASHBOARD_URL}/auth/sign-up`)} title={strings.shared.trial} />
            <MainMenu
              items={[
                {
                  title: strings.menu.legal,
                  to: `/${lang}/privacy-policy`
                },
                {
                  title: strings.menu.blog,
                  to: `/${lang}/blog`
                }
              ]}
            />
            <LanguageSwitcher
              showFlags
              lang={lang}
              onSelect={setLanguage}
            />
          </div>
        </div>
      </div>
    </section>
  );
};




// WEBPACK FOOTER //
// ./src/components/Header/Header.js